export default __webpack_public_path__ + "static/media/gg-card.794a6f8e.png";